module.exports = __webpack_public_path__ + "media/images/arrow-left-button-dark-a9529c25ac16ddf2f4bb99710b1b851f.svg";